import React from 'react';
import LazyImage from '../../../Layouts/LazyImage';
import { Typography } from '@mui/material';
import { LinkedIn } from '@mui/icons-material';

import ActiveLink from '../../../Layouts/ActiveLink';

import style from './style';

const Founder = ({ data }) => {
  const classes = style();
  return (
    <div>
      <LazyImage
        quality={97}
        sizes={sizes}
        radius={'50%'}
        className={classes.founderImg}
        src={data?.img}
      />
      <Typography variant="h5">{data?.name}</Typography>
      <Typography variant="subtitle1">{data?.role}</Typography>
      <Typography
        variant="subtitle1"
        sx={{ color: 'tertiary.purplishBlue' }}
        gutterBottom
      >
        {data?.strongIn || data?.roleIn}
      </Typography>

      {data?.socialNetwork && (
        <ActiveLink
          href={data?.socialNetwork?.linkedin}
          target="_blank"
          rel="noreferrer"
        >
          <LinkedIn />
        </ActiveLink>
      )}
    </div>
  );
};

const sizes = {
  xxl: [170, 170, false],
};

export default Founder;
